// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1alth","consentsList":"PatientConsents_consentsList__36Mfm","consentsListEmpty":"PatientConsents_consentsListEmpty__3Eik6"};